import _ from 'lodash';
export const getOldItem = (id, pastOrderedProduct) => {
  let selectedItem;
  if (pastOrderedProduct?.options?.length > 0) {
    pastOrderedProduct.options.map((option) => {
      if (option?.items?.length > 0) {
        option.items.forEach((item) => {
          if (item.sub_items?.length > 0) {
            item.sub_items.forEach((subItem) => {
              if (subItem.item_id === id) {
                selectedItem = subItem;
              }
            });
          } else {
            if (item.item_id === id) {
              selectedItem = item;
            }
          }
        });
      } else if (option?.sub_options?.length > 0) {
        option.sub_options.forEach((suboption) => {
          suboption.items.forEach((item) => {
            if (item.sub_items?.length > 0) {
              item.sub_items.forEach((subItem) => {
                if (subItem.item_id === id) {
                  selectedItem = subItem;
                }
              });
            } else {
              if (item.item_id === id) {
                selectedItem = item;
              }
            }
          });
        });
      }
    });
  }
  return selectedItem;
};
export const isItemUnavailable = (item) => {
  if (!item.is_available) return true;
  else return false;
};

export const combinedSelectedProduct = (pastOrderedProduct, currentProduct) => {
  let finalProduct = { ...currentProduct };
  if (currentProduct?.options?.length > 0) {
    currentProduct.options.map((option, optionIndex) => {
      if (option?.items?.length > 0) {
        option.items.forEach((item, itemIndex) => {
          if (item.sub_items?.length > 0) {
            item.sub_items.forEach((subItem, subItemIndex) => {
              const oldItem = getOldItem(subItem.item_id, pastOrderedProduct);
              if (oldItem) {
                finalProduct.options[optionIndex].items[itemIndex].sub_items[
                  subItemIndex
                ] = {
                  ...subItem,
                  quantity: !isItemUnavailable(subItem) ? oldItem.quantity : 0,
                };
              } else {
                finalProduct.options[optionIndex].items[itemIndex].sub_items[
                  subItemIndex
                ] = {
                  ...subItem,
                  quantity: 0,
                };
              }
            });
          } else {
            const oldItem = getOldItem(item.item_id, pastOrderedProduct);
            if (oldItem) {
              finalProduct.options[optionIndex].items[itemIndex] = {
                ...item,
                quantity: !isItemUnavailable(item) ? oldItem.quantity : 0,
              };
            } else {
              finalProduct.options[optionIndex].items[itemIndex] = {
                ...item,
                quantity: 0,
              };
            }
          }
        });
      } else if (option?.sub_options?.length > 0) {
        option.sub_options.forEach((suboption, subOptionIndex) => {
          suboption.items.forEach((item, itemIndex) => {
            if (item.sub_items?.length > 0) {
              item.sub_items.forEach((subItem, subItemIndex) => {
                const oldItem = getOldItem(subItem.item_id, pastOrderedProduct);
                if (oldItem) {
                  finalProduct.options[optionIndex].sub_options[
                    subOptionIndex
                  ].items[itemIndex].sub_items[subItemIndex] = {
                    ...subItem,
                    quantity: !isItemUnavailable(subItem)
                      ? oldItem.quantity
                      : 0,
                  };
                } else {
                  finalProduct.options[optionIndex].sub_options[
                    subOptionIndex
                  ].items[itemIndex].sub_items[subItemIndex] = {
                    ...subItem,
                    quantity: 0,
                  };
                }
              });
            } else {
              const oldItem = getOldItem(item.item_id, pastOrderedProduct);
              finalProduct.options[optionIndex].sub_options[
                subOptionIndex
              ].items[itemIndex] = {
                ...item,
                quantity:
                  !isItemUnavailable(item) && oldItem?.quantity
                    ? oldItem.quantity
                    : 0,
              };
            }
          });
        });
      }
    });
  }
  const pastVariantID = pastOrderedProduct?.variant_id;
  const selectedVariant = currentProduct.prices.reduce((acc, variant) => {
    if (variant.variant_id === pastVariantID) {
      acc = variant;
    } else if (variant.is_default && !acc) {
      acc = variant;
    }
    return acc;
  }, null);
  finalProduct = {
    ...finalProduct,
    quantity: pastOrderedProduct?.quantity || 0,
    price: selectedVariant.price,
    variant_id: selectedVariant.variant_id,
    variant_name: selectedVariant.name,
  };
  return finalProduct;
};
export const handleCompareProducts = (
  pastOrderedProduct,
  selectedProduct,
  updateShortageMessageInOrderAgainProducts,
  editPreviousProductConfiguration,
  addProductsToCart,
  setPastOrderedProduct,
  setToastMessage
) => {
  let localShortageMessage = {
    variantName: '',
    productName: selectedProduct?.name,
    itemShortageMessages: [],
  };
  let pastOrderItems = [];
  let currentProductItems = [];
  let pastOptions = [];
  let currentOptions = [];
  let finalSelectedProduct;
  let unavailableItems = [];

  // create message for items
  // past orders
  if ('options' in pastOrderedProduct) {
    pastOrderedProduct.options.forEach((option) => {
      if (option.items?.length > 0) {
        pastOptions.push({
          id: option.option_id,
          minimum_pick: option.minimum_pick,
        });
        option.items.forEach((item) => {
          if ('sub_items' in item && item.sub_items.length > 0) {
            item.sub_items.forEach((subItem) => {
              pastOrderItems.push({
                id: subItem.item_id,
                name: subItem.name,
                is_available: subItem.is_available,
              });
            });
          } else {
            pastOrderItems.push({
              id: item.item_id,
              name: item.name,
              is_available: item.is_available,
            });
          }
        });
      }
      if (option.sub_options.length > 0) {
        option.sub_options.forEach((suboption) => {
          pastOptions.push({
            id: suboption.option_id,
            minimum_pick: suboption.minimum_pick,
          });
          suboption.items.forEach((item) => {
            if ('sub_items' in item && item.sub_items.length > 0) {
              item.sub_items.forEach((subItem) => {
                pastOrderItems.push({
                  id: subItem.item_id,
                  name: subItem.name,
                  is_available: subItem.is_available,
                });
              });
            } else {
              pastOrderItems.push({
                id: item.item_id,
                name: item.name,
                is_available: item.is_available,
              });
            }
          });
        });
      }
    });
  }
  // current product
  if ('options' in selectedProduct) {
    selectedProduct.options.forEach((option) => {
      currentOptions.push({
        id: option.option_id,
        minimum_pick: option.minimum_pick,
      });
      if (option?.items?.length > 0) {
        option.items.forEach((item) => {
          if ('sub_items' in item && item.sub_items.length > 0) {
            item.sub_items.forEach((subItem) => {
              currentProductItems.push({
                id: subItem.item_id,
                name: subItem.name,
                is_available: subItem.is_available,
                is_default: subItem.is_default,
                quantity: subItem.quantity,
              });
            });
          } else {
            currentProductItems.push({
              id: item.item_id,
              name: item.name,
              is_available: item.is_available,
              is_default: item.is_default,
              quantity: item.quantity,
            });
          }
        });
      }
      if (option?.sub_options?.length > 0) {
        option.sub_options.forEach((suboption) => {
          currentOptions.push({
            id: suboption.option_id,
            minimum_pick: suboption.minimum_pick,
          });
          suboption.items.forEach((item) => {
            if ('sub_items' in item && item.sub_items.length > 0) {
              item.sub_items.forEach((subItem) => {
                currentProductItems.push({
                  id: subItem.item_id,
                  name: subItem.name,
                  is_available: subItem.is_available,
                  is_default: subItem.is_default,
                  quantity: subItem.quantity,
                });
              });
            } else {
              currentProductItems.push({
                id: item.item_id,
                name: item.name,
                is_available: item.is_available,
                is_default: item.is_default,
                quantity: item.quantity,
              });
            }
          });
        });
      }
    });
  }
  // create message for items
  const pastOrderItemIDs = pastOrderItems.map((item) => item.id);
  const currentProductItemIDs = currentProductItems.map((item) => item.id);
  let shortageMessages = pastOrderItems.reduce((acc, current) => {
    const findCurrentItem = currentProductItems.find(
      (item) => item.id === current.id
    );
    if (!findCurrentItem || !findCurrentItem?.is_available) {
      acc.push(current.name);
    }
    return acc;
  }, []);
  currentProductItems.forEach((curr) => {
    if (
      !curr.is_available &&
      curr.is_default &&
      curr.quantity > 0 &&
      !pastOrderItemIDs.includes(curr.id)
    )
      unavailableItems.push(curr.name);
  });
  localShortageMessage = {
    ...localShortageMessage,
    itemShortageMessages:
      shortageMessages.length > 0
        ? [...shortageMessages, ...unavailableItems]
        : shortageMessages,
  };

  updateShortageMessageInOrderAgainProducts(localShortageMessage);
  finalSelectedProduct = combinedSelectedProduct(
    pastOrderedProduct,
    selectedProduct,
    pastOrderItemIDs
  );
  // compare and action
  if (shortageMessages.length > 0) {
    editPreviousProductConfiguration(finalSelectedProduct);
  } else {
    addProductsToCart([finalSelectedProduct], setToastMessage);
  }
  setPastOrderedProduct({});
};

export const isProductOrComboDisabled = (items, selectedItem, itemType) => {
  let isDisabled = false;
  if (itemType === 'product') {
    const currrentProduct = items.find(
      (product) => product.product_id === selectedItem.product_id
    );
    if (currrentProduct) {
      if (!currrentProduct.is_product_available) {
        isDisabled = true;
      }
    } else {
      isDisabled = true;
    }
  } else {
  }
  return isDisabled;
};

export const getAvailablePastOrderedProducts = (
  pastProducts,
  currentProducts
) => {
  // const currentProductIDs = currentProducts.map((item) => item.product_id);
  const availablePastOrderedProduct = currentProducts.reduce(
    (acc, curr, index) => {
      const pastProduct = pastProducts.find(
        (past) => past.product_id === curr.product_id
      );
      const combinedProd = combinedSelectedProduct(pastProduct, curr);
      acc.push(combinedProd);
      return acc;
    },
    []
  );

  return availablePastOrderedProduct;
};
